<div class="modal-body">
  @switch (data.status) {
    @case (VerifyGanaStatus.SUCCESS) {
      <div class="flex flex-col items-center justify-center">
        <i nz-icon class="pb-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none">
            <mask
              id="mask0_12909_205781"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="41"
              height="41"
            >
              <rect x="0.5" y="0.5" width="40" height="40" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_12909_205781)">
              <path
                d="M18.9974 28.1673L30.7474 16.4173L28.4141 14.084L18.9974 23.5007L14.2474 18.7507L11.9141 21.084L18.9974 28.1673ZM21.3307 37.1673C19.0252 37.1673 16.8585 36.7298 14.8307 35.8548C12.803 34.9798 11.0391 33.7923 9.53906 32.2923C8.03906 30.7923 6.85156 29.0284 5.97656 27.0007C5.10156 24.9729 4.66406 22.8062 4.66406 20.5007C4.66406 18.1951 5.10156 16.0284 5.97656 14.0007C6.85156 11.9729 8.03906 10.209 9.53906 8.70898C11.0391 7.20898 12.803 6.02148 14.8307 5.14648C16.8585 4.27148 19.0252 3.83398 21.3307 3.83398C23.6363 3.83398 25.803 4.27148 27.8307 5.14648C29.8585 6.02148 31.6224 7.20898 33.1224 8.70898C34.6224 10.209 35.8099 11.9729 36.6849 14.0007C37.5599 16.0284 37.9974 18.1951 37.9974 20.5007C37.9974 22.8062 37.5599 24.9729 36.6849 27.0007C35.8099 29.0284 34.6224 30.7923 33.1224 32.2923C31.6224 33.7923 29.8585 34.9798 27.8307 35.8548C25.803 36.7298 23.6363 37.1673 21.3307 37.1673Z"
                fill="#0D9443"
              />
            </g>
          </svg>
        </i>
        <h4 class="paragraph-large py-2 bold">{{ 'balance.ganas_success' | translate }}</h4>
        <p class="paragraph-medium regular text-center">{{ 'balance.ganas_success_msg' | translate }}</p>
      </div>
    }
    @case (VerifyGanaStatus.FAIL) {
      <div class="flex flex-col items-center justify-center">
        <i nz-icon class="pb-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none">
            <mask
              id="mask0_12909_215510"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="49"
              height="48"
            >
              <rect x="0.5" width="48" height="48" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_12909_215510)">
              <path
                d="M18.3 34L25.5 26.8L32.7 34L35.5 31.2L28.3 24L35.5 16.8L32.7 14L25.5 21.2L18.3 14L15.5 16.8L22.7 24L15.5 31.2L18.3 34ZM25.5 44C22.7333 44 20.1333 43.475 17.7 42.425C15.2667 41.375 13.15 39.95 11.35 38.15C9.55 36.35 8.125 34.2333 7.075 31.8C6.025 29.3667 5.5 26.7667 5.5 24C5.5 21.2333 6.025 18.6333 7.075 16.2C8.125 13.7667 9.55 11.65 11.35 9.85C13.15 8.05 15.2667 6.625 17.7 5.575C20.1333 4.525 22.7333 4 25.5 4C28.2667 4 30.8667 4.525 33.3 5.575C35.7333 6.625 37.85 8.05 39.65 9.85C41.45 11.65 42.875 13.7667 43.925 16.2C44.975 18.6333 45.5 21.2333 45.5 24C45.5 26.7667 44.975 29.3667 43.925 31.8C42.875 34.2333 41.45 36.35 39.65 38.15C37.85 39.95 35.7333 41.375 33.3 42.425C30.8667 43.475 28.2667 44 25.5 44Z"
                fill="#DF2525"
              />
            </g>
          </svg>
        </i>
        <h4 class="paragraph-large py-2 bold">{{ 'balance.ganas_fail' | translate }}</h4>
        <p class="paragraph-medium regular text-center">{{ 'balance.ganas_fail_msg' | translate }}</p>
      </div>
    }
  }
  <div *nzModalFooter class="flex flex-col md:flex-row justify-end gap-2">
    @if (isValidatedGanas) {
      <korviu-button color="ghost" (click)="goToBalance()" class="w-full">{{
        'balance.return_to_balance' | translate
      }}</korviu-button>
    }
    @if (isValidatedGanas) {
      <korviu-button color="tertiary" (click)="openShareGanas()" class="w-full">{{
        'balance.share_more-ganas' | translate
      }}</korviu-button>
    }
    @if (!isValidatedGanas) {
      <korviu-button color="ghost" (click)="tryAgain()" class="w-full">{{
        'common.tryAgain' | translate
      }}</korviu-button>
    }
    @if (!isValidatedGanas) {
      <korviu-button color="tertiary" (click)="sendInvite()" class="w-full">{{
        'balance.send_invite' | translate
      }}</korviu-button>
    }
  </div>
</div>
